import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";

import PatentInfo from "./components/PatentInfo.vue";
import PatentClaims from "./components/PatentClaims.vue";
import PatentSpecification from "./components/PatentSpecification.vue";
import PatentDrawing from "./components/PatentDrawing.vue";
import PatentPdfViewer from "./components/PatentPdfViewer.vue";
import PatentLinks from "./components/PatentLinks.vue";
import PatentIndexing from "./components/PatentIndexing.vue";
import PatentCategory from "./components/PatentCategory.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PatentView',
  props: {
  patent: { required: true, default: () => ({}), type: Object },
  treeData: { default: () => "", type: String },
},
  emits: ["refresh", "refresh-tree"],
  setup(__props, { expose }) {





const activeName = ref("info");
const visible = ref(false);

const open = () => {
  visible.value = true;
};

const closeDialog = () => {
  visible.value = false;
};

const handleClose = () => {
  closeDialog();
};

expose({ open, close: closeDialog });

return { __sfc: true,activeName, visible, open, closeDialog, handleClose, PatentInfo, PatentClaims, PatentSpecification, PatentDrawing, PatentPdfViewer, PatentLinks, PatentIndexing, PatentCategory }
}

})